import { Stack } from '@mui/material';
import { Option, Select } from 'components/ui/FormControls';
import React, { FC } from 'react';

import { ChannelSubscriptionType } from '../../../../shared/types';
import {
    ALL_SUBSCRIPTION_FILTER_VALUE,
    INACTIVE_SUBSCRIPTION_FILTER_VALUE,
    subscriptionTypeLabels,
} from './utils';
import { SubscriptionStatusFilter, SubscriptionTypeFilter } from './types';

interface UserChannelSubscriptionsFiltersProps {
    subscriptionState: SubscriptionStatusFilter;
    subscriptionType: SubscriptionTypeFilter;
    onSubscriptionStateChange: (value: SubscriptionStatusFilter) => void;
    onSubscriptionTypeChange: (value: SubscriptionTypeFilter) => void;
}

type TypedOption<TValue> = Omit<Option, 'value'> & {
    value: TValue;
};

const statusOptions: TypedOption<SubscriptionStatusFilter>[] = [
    { label: 'All statuses', value: ALL_SUBSCRIPTION_FILTER_VALUE },
    { label: 'ACTIVE', value: 'active' },
    { label: 'INACTIVE', value: INACTIVE_SUBSCRIPTION_FILTER_VALUE },
];

const subscriptionTypeOptions: TypedOption<SubscriptionTypeFilter>[] = [
    { label: 'All subscriptions', value: ALL_SUBSCRIPTION_FILTER_VALUE },
    ...Object.entries(subscriptionTypeLabels).map(([value, label]) => ({
        label,
        value: value as ChannelSubscriptionType,
    })),
];

const UserChannelSubscriptionsFilters: FC<
    UserChannelSubscriptionsFiltersProps
> = ({
    subscriptionState,
    subscriptionType,
    onSubscriptionStateChange,
    onSubscriptionTypeChange,
}) => (
    <Stack direction="row" spacing={1.5} sx={{ mb: 2 }}>
        <Select
            ariaLabel="Filter channel subscriptions by subscription type"
            clearable={false}
            hiddenLabel
            searchable={false}
            sx={{ width: 220 }}
            value={subscriptionType}
            onChange={(option: Option) =>
                onSubscriptionTypeChange(option.value as SubscriptionTypeFilter)
            }
            options={subscriptionTypeOptions}
        />
        <Select
            ariaLabel="Filter channel subscriptions by status"
            clearable={false}
            hiddenLabel
            searchable={false}
            sx={{ width: 220 }}
            value={subscriptionState}
            onChange={(option: Option) =>
                onSubscriptionStateChange(
                    option.value as SubscriptionStatusFilter
                )
            }
            options={statusOptions}
        />
    </Stack>
);

export default UserChannelSubscriptionsFilters;
